import {GateTypeEnum} from "@/modules/action-points/enums";

export const TYPES = {
  Rewarder: Symbol.for('Rewarder'),
  AchievementHandler: Symbol.for('AchievementHandler'),
};

export type AchievementRewardsType = { [key in GateTypeEnum]?: number };
